import { type Accessor, createSignal, onMount } from "solid-js";
import { isServer } from "solid-js/web";

export type DetectedOS = "mac" | "windows" | "linux" | "other" | "unknown";

// iPadOS 13+ reports the same UA as desktop Safari on macOS; the only reliable
// signal that distinguishes is maxTouchPoints > 1.
function detect(): DetectedOS {
  if (typeof navigator === "undefined") return "unknown";
  const ua = (navigator.userAgent || "").toLowerCase();
  const looksLikeMac = /macintosh|mac os x|darwin/.test(ua);
  const isTouchMac = looksLikeMac && typeof navigator.maxTouchPoints === "number" && navigator.maxTouchPoints > 1;
  if (isTouchMac) return "other";
  if (looksLikeMac) return "mac";
  if (/windows|win32|win64/.test(ua)) return "windows";
  if (/iphone|ipad|ipod|android/.test(ua)) return "other";
  if (ua.includes("linux")) return "linux";
  return "other";
}

export function useOS(): Accessor<DetectedOS> {
  const [os, setOS] = createSignal<DetectedOS>("unknown");
  onMount(() => {
    if (isServer) return;
    setOS(detect());
  });
  return os;
}
